/**
 * 系統停止營運設定
 *
 * 這裡指的是 weserve 點餐系統本身不再提供服務，而非店家歇業。
 * 到達 SERVICE_SHUTDOWN_AT 之後，全站只保留店家資訊與訂單查詢，
 * 所有與下單相關的頁面（菜單、購物車、品項、揪團、優惠券…）一律導回店家主頁。
 */

// 停止營運時間（台北時間 UTC+8）
export const SERVICE_SHUTDOWN_AT = new Date('2026-09-10T00:00:00+08:00');

// 停業後仍可進入的路徑（相對於 /:storeId）
export const SHUTDOWN_ALLOW_PATHS = ['', 'storeInfo', 'orders'];

export const isServiceShutdown = () => Date.now() >= SERVICE_SHUTDOWN_AT.getTime();

export default isServiceShutdown;
